export default __webpack_public_path__ + "static/media/IBMInfomation.3631e00f.svg";